import { render, staticRenderFns } from "./Themes.vue?vue&type=template&id=2b467680"
import script from "./Themes.vue?vue&type=script&lang=js"
export * from "./Themes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports